// NPM PACKAGE IMPORTS
import React from "react";
import { Box, Link, Typography } from "@mui/material";
import "./stylesLogin.scss";
import logo from "../../assets/logos/white_msuite_landscape.png";
import MarketingContent from "./MarketingContent";
import LoginExperienceRouter from "./LoginExperienceRouter";
import AppVersion from "../common/AppVersion";
import { completeLoginWithToken } from "../sso/authUtils";

export default function LoginPage({
  urlError = "",
  onClearUrlError,
  setIsForgotPassword,
  onPasswordResetRequired,
}) {
  const handleLoginSuccess = async (token) => {
    await completeLoginWithToken(token);
  };

  return (
    <Box display="flex" minHeight="100vh" bgcolor="background.default">
      <Box
        position="absolute"
        top={31}
        left={43}
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
      >
        <Link
          href="https://msuite.com"
          target="_blank"
          rel="noopener noreferrer"
          display="inline-block"
        >
          <img src={logo} alt="MSUITE Logo" height={91} width={167} />
        </Link>
      </Box>
      <Box flex={1} display="flex" alignItems="center" justifyContent="center">
        <Box
          className="login-wrapper"
          paddingX={6}
          paddingY={6.75}
          borderRadius={2}
          boxShadow={3}
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", sm: "100%", md: "50%" },
          }}
          bgcolor="var(--elevation-outlined, rgba(255, 255, 255, 0.12))"
          border="1px solid var(--elevation-outlined, rgba(255, 255, 255, 0.12))"
        >
          <Typography
            variant="h4"
            mb={2}
            lineHeight={"42px"}
            letterSpacing={"0.25px"}
          >
            Welcome!
          </Typography>
          <LoginExperienceRouter
            urlError={urlError}
            onClearUrlError={onClearUrlError}
            onLoginSuccess={handleLoginSuccess}
            setIsForgotPassword={setIsForgotPassword}
            onPasswordResetRequired={onPasswordResetRequired}
          />
        </Box>
      </Box>
      <MarketingContent />
      <AppVersion />
    </Box>
  );
}
